import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import type { PhoneCountryCode } from '@/entities/clients-filter.entity';
import { PHONE_COUNTRY_FILTER_OPTIONS } from '@crave/config/phone-country';

type PhoneCountryExclusionFieldProps = {
	value: PhoneCountryCode[];
	onChange: (next: PhoneCountryCode[]) => void;
	mode?: 'client' | 'simRow';
};

export default function PhoneCountryExclusionField({ value, onChange, mode = 'client' }: PhoneCountryExclusionFieldProps) {
	const hint =
		mode === 'simRow'
			? 'Скрывает строки SIM выбранных стран (в том числе без номера, если страна SIM известна).'
			: 'Скрывает клиента только если все его номера/SIM из выбранных стран. Если есть другая SIM - показываем. Клиентов без номеров и без известной страны SIM не скрывают (используйте «Номера: Нет»).';

	function toggle(code: PhoneCountryCode) {
		if (value.includes(code)) {
			onChange(value.filter(c => c !== code));
		} else {
			onChange([...value, code].sort());
		}
	}

	return (
		<div className='grid gap-2'>
			<Label className='text-sm font-normal'>Исключить страны SIM</Label>
			<div className='flex flex-wrap gap-1.5'>
				{PHONE_COUNTRY_FILTER_OPTIONS.map(opt => {
					const active = value.includes(opt.code);
					return (
						<Button
							key={opt.code}
							type='button'
							size='sm'
							variant={active ? 'secondary' : 'outline'}
							className='h-8'
							onClick={() => toggle(opt.code)}
						>
							{opt.code} · {opt.labelRu}
						</Button>
					);
				})}
			</div>
			<p className='text-xs text-muted-foreground leading-snug'>{hint}</p>
		</div>
	);
}
